import { Route } from 'react-router-dom';
import Layout from '../components/layout';
import UserSetting from '../Pages/Setting/UserSetting';
import ProtectedRoute from '../components/ProtectedRoute';

export const SettingRoutes = ({ menuActive, setMenuActive }) => (
  <>
    <Route path="/setting" element={
      <ProtectedRoute>
        <Layout activePage='setting' menuActive={menuActive} setMenuActive={setMenuActive}>
          <UserSetting />
        </Layout>
      </ProtectedRoute>
    } />
  </>
);
